import React, { ReactElement } from 'react';
import classnames from 'classnames';
import { LINKS, FooterLink } from './constants';

type FooterColourTypes =
  | 'default'
  | 'primary'
  | 'secondary'
  | 'tertiary'
  | 'dark'
  | 'light';

export interface FooterProps {
  className?: string;
  colour?: FooterColourTypes;
  links?: FooterLink[];
}

export function Footer({
  className,
  colour = 'default',
  links = LINKS,
}: FooterProps): ReactElement {
  const classes = classnames('footer', className, {
    [`footer--${colour}`]: colour !== 'default',
  });

  return (
    <footer className={classes}>
      <div className="footer__links">
        <ul className="list list--inline">
          {links.map(({ name, href }) => (
            <li key={name}>
              <a href={href} target="_blank" rel="noreferrer noopener">
                {name}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </footer>
  );
}
